package pt.at.oss.kotlin.pages.i18n

import pt.at.oss.kotlin.core.i18n.I18nBase
import pt.at.oss.kotlin.core.i18n.PageLocale

/**
 * Translations for the VAT Returns List page.
 */
enum class VatReturnsListI18n(override val translations: Map<PageLocale, String>) : I18nBase {

    FORM_TITLE(mapOf(PageLocale.PT to "Consultar Declarações")),
    INFO_TITLE(mapOf(PageLocale.PT to "Para obter o documento de pagamento, selecione a Declaração e pressione: Obter DUC")),
    // Table columns
    REFERENCE_COLUMN(mapOf(PageLocale.PT to "Referência")),
    VERSION_COLUMN(mapOf(PageLocale.PT to "Versão")),
    PERIOD_COLUMN(mapOf(PageLocale.PT to "Período")),
    VIGENTE_COLUMN(mapOf(PageLocale.PT to "Vigência")),
    RETURN_ACTIONS_COLUMN(mapOf(PageLocale.PT to "")),
    // Row actions
    RETURN_DETAIL_BUTTON(mapOf(PageLocale.PT to "detalhe")),
    RETURN_DUC_BUTTON(mapOf(PageLocale.PT to "obter duc")),
    // Search form
    SELECT_OSS_NUMBER_LABEL(mapOf(PageLocale.PT to "Número OSS")),
    SELECT_IOSS_NUMBER_LABEL(mapOf(PageLocale.PT to "Número IOSS")),
    SELECT_VIGENTE_LABEL(mapOf(PageLocale.PT to "Vigência")),
    SELECT_PERIOD_LABEL(mapOf(PageLocale.PT to "Período")),
    // Search buttons
    CLEAR_BTN_LABEL(mapOf(PageLocale.PT to "limpar")),
    SEARCH_BTN_LABEL(mapOf(PageLocale.PT to "pesquisar")),

    ;
}
